import { createElement } from "react";
import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import { requirePermission } from "../../../../shared/routing/requirePermission";
import { COMPANIES_VIEW } from "../../organizationPermissions";
import {
  archivedCompaniesSearchSchema,
  companiesSearchSchema,
} from "./searchSchemas";
import type { OrganizationRouteFactory } from "./organizationRouteContext";

const CompaniesListScreen = lazyRouteComponent(
  () => import("../CompaniesListScreen"),
  "CompaniesListScreen",
);
const ArchivedCompaniesListScreen = lazyRouteComponent(
  () => import("../ArchivedCompaniesListScreen"),
  "ArchivedCompaniesListScreen",
);

export const createCompaniesRoutes: OrganizationRouteFactory = ({
  context,
  companies,
}) => [
  createRoute({
    getParentRoute: context.getParentRoute,
    path: `${context.basePath}/companies`,
    validateSearch: companiesSearchSchema,
    beforeLoad: requirePermission([COMPANIES_VIEW]),
    component: () =>
      createElement(CompaniesListScreen, {
        repository: companies,
        basePath: context.basePath,
      }),
  }),
  createRoute({
    getParentRoute: context.getParentRoute,
    path: `${context.basePath}/companies/archived`,
    validateSearch: archivedCompaniesSearchSchema,
    beforeLoad: requirePermission([COMPANIES_VIEW]),
    component: () =>
      createElement(ArchivedCompaniesListScreen, {
        repository: companies,
        basePath: context.basePath,
      }),
  }),
];
